import {
	getRequest,
	getRequestWithBaseUrl,
	patchRequest,
	postRequest,
} from "../utils/requests";
import { config, endpoints } from "../utils/urls";

export const searchLicences = (params) => {
	return getRequest(endpoints.license.search, params);
};

export const getTemplate = () => {
	return getRequestWithBaseUrl(
		endpoints.license.getTemplate,
		undefined,
		undefined,
		config.publicApiBaseUrl,
	);
};

export const generateLicence = (payload) => {
	return postRequest(endpoints.license.generate, payload);
};

export const uploadLicenceSvg = (payload) => {
	return postRequest(endpoints.license.uploadFile, payload);
};

export const updateLicence = (id, payload) => {
	return patchRequest(endpoints.license.updateLicence(id), payload);
};

export const exportLicencesCsv = () => {
	return getRequest(endpoints.license.exportCsv, undefined, {
		Accept: "text/csv, application/json, */*",
	});
};

export const updateBulkLicences = (payload) => {
	return postRequest(endpoints.license.updateBulk, payload);
};
